// /v2 is PEOPLE's own site, served from the root of ppl-ai.com. An id keeps its number for good:
// links and lead attribution carry it.

const SITE_VERSIONS = ["v2"] as const;

export type SiteVersion = (typeof SITE_VERSIONS)[number];

// Digits are required so real routes like /vendors are not mistaken for a version.
const VERSION_PREFIX = /^\/(v\d+)(?=\/|$)/;

function isKnownVersion(value: string): value is SiteVersion {
  return (SITE_VERSIONS as readonly string[]).includes(value);
}

export function getSiteVersion(pathname: string): SiteVersion | null {
  const match = VERSION_PREFIX.exec(pathname);
  const version = match?.[1];
  return version && isKnownVersion(version) ? version : null;
}

export function splitSiteVersion(pathname: string): {
  version: SiteVersion | null;
  basePath: string;
} {
  const version = getSiteVersion(pathname);
  if (!version) return { version: null, basePath: pathname };
  return { version, basePath: pathname.slice(version.length + 1) || "/" };
}
